import { motion } from 'motion/react';
import styles from './BgVideoCloud.module.css';

import bgVideo from '../../assets/video/bgVideoCloud.webm';
import bgPoster from '../../assets/images/bgPosterCloud.webp';

export const BgVideoCloud = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6, delay: 0.7 }}
      exit={{ opacity: 0 }}
      className={styles.bgVideoWrapper}
    >
      <video playsInline muted="muted" loop poster={bgPoster} autoPlay={true}>
        <source src={bgVideo} type="video/webm" />
      </video>
    </motion.div>
  );
};
